import { isEmpty } from "lodash";
import { urls } from "../constants/app";
import request from "./utils/request";
import { promocodeAdapter, promoGoodsAdapter } from "../utils/goods";
import { validatePromocode } from "../utils/common";

export function addPositionNewOrder(good, setting) {
    return (dispatch) => {
        dispatch({ type: 'ADD_POSITION_NEW_ORDER', setting: setting, good: good }); 
        dispatch({ type: 'CALCULATION_TOTALPRICE_NEW_ORDER'}); 
    }
}

export function deletePositionNewOrder(index) {
    return (dispatch) => {
        dispatch({ type: 'DELETE_POSITION_NEW_ORDER', index: index }); 
        dispatch({ type: 'CALCULATION_TOTALPRICE_NEW_ORDER'}); 
    }
}

export function changeCountPosition(index, count, type, value) {
    if(type === 'plus' && count < 100)
        return (dispatch) => {
            dispatch({ type: 'PLUS_COUNT_POSITION_NEW_ORDER', index: index }); 
            dispatch({ type: 'CALCULATION_TOTALPRICE_NEW_ORDER'}); 
        }

    if(type === 'minus')  
    {  
        if(count === 1)
            return (dispatch) => {
                dispatch({ type: 'DELETE_POSITION_NEW_ORDER', index: index }); 
                dispatch({ type: 'CALCULATION_TOTALPRICE_NEW_ORDER'}); 
            }

        return (dispatch) => {
            dispatch({ type: 'MINUS_COUNT_POSITION_NEW_ORDER', index: index }); 
            dispatch({ type: 'CALCULATION_TOTALPRICE_NEW_ORDER'}); 
        }
    }        
    
    if(type === 'handle')
    {
        if(parseInt(value) >= 99)
            return (dispatch) => {
                dispatch({ type: 'CHANGE_COUNT_POSITION_NEW_ORDER', index: index, value: 99}); 
                dispatch({ type: 'CALCULATION_TOTALPRICE_NEW_ORDER'}); 
            }

        return (dispatch) => {
            dispatch({ type: 'CHANGE_COUNT_POSITION_NEW_ORDER', index: index, value: parseInt(value)}); 
            dispatch({ type: 'CALCULATION_TOTALPRICE_NEW_ORDER'}); 
        }
    }
}

export function addAdditivesWOK(index, good, field){
    return (dispatch) => {
        dispatch({ type: 'ADD_ADDITIVES_NEW_ORDER', index, good, field});
        dispatch({type: 'CALCULATE_WOK_PRICE', index: index});
        dispatch({ type: 'CALCULATION_TOTALPRICE_NEW_ORDER'});        
    }
}

export function deleteAdditivesNewOrder(index, idAdditives, subtype) {
    return (dispatch) => {
        dispatch({ type: 'DELETE_ADDITIVES_NEW_ORDER', index: index, idAdditives: idAdditives, subtype: subtype });        
        dispatch({type: 'CALCULATE_WOK_PRICE', index: index});
        dispatch({ type: 'CALCULATION_TOTALPRICE_NEW_ORDER'});
    }
}

export function changeCountAdditives(index, count, type, idAdditives, subtype, value) {
    if(type === 'plus' && count < 100)
        return (dispatch) => {
            dispatch({ type: 'PLUS_COUNT_ADDITIVES_NEW_ORDER', index: index, idAdditives: idAdditives, subtype: subtype }); 
            dispatch({type: 'CALCULATE_WOK_PRICE', index: index})
            dispatch({ type: 'CALCULATION_TOTALPRICE_NEW_ORDER'}); 
        }

    if(type === 'minus')  
    {  
        if(count === 1)
            return (dispatch) => {
                if(subtype === 'main')
                    dispatch({ type: 'DELETE_POSITION_NEW_ORDER', index: index }); 
                if(subtype !== 'main')
                    dispatch({ type: 'DELETE_ADDITIVES_NEW_ORDER', index: index, idAdditives: idAdditives, subtype: subtype }); 
                dispatch({type: 'CALCULATE_WOK_PRICE', index: index})
                dispatch({ type: 'CALCULATION_TOTALPRICE_NEW_ORDER'}); 
            }

        return (dispatch) => {
            dispatch({ type: 'MINUS_COUNT_ADDITIVES_NEW_ORDER', index: index, idAdditives: idAdditives, subtype: subtype }); 
            dispatch({type: 'CALCULATE_WOK_PRICE', index: index})
            dispatch({ type: 'CALCULATION_TOTALPRICE_NEW_ORDER'}); 
        }
    }        
    
    if(type === 'handle')
    {
        if(parseInt(value) >= 99)
            return (dispatch) => {
                dispatch({ type: 'CHANGE_COUNT_ADDITIVES_NEW_ORDER', index: index, value: 99, idAdditives: idAdditives, subtype: subtype }); 
                dispatch({type: 'CALCULATE_WOK_PRICE', index: index})
                dispatch({ type: 'CALCULATION_TOTALPRICE_NEW_ORDER'}); 
            }

        return (dispatch) => {
            dispatch({ type: 'CHANGE_COUNT_ADDITIVES_NEW_ORDER', index: index, value: parseInt(value), idAdditives: idAdditives, subtype: subtype }); 
            dispatch({type: 'CALCULATE_WOK_PRICE', index: index})
            dispatch({ type: 'CALCULATION_TOTALPRICE_NEW_ORDER'}); 
        }
    }
}

export function changeUnit(value) {
    if(value === 0)
        return (dispatch) => {
            dispatch({ type: 'CHANGE_INFORMATION_NEW_ORDER', subtype: 'unit', value: null }); 
        }
    
    return (dispatch) => {
        dispatch({ type: 'CHANGE_INFORMATION_NEW_ORDER', subtype: 'unit', value: value }); 
    }
}

export function changeSale(type, value) {
    if(type === 'persent'){
        return (dispatch) => {
            dispatch({ type: 'SET_SALE_PERSENT_NEW_ORDER', value: value }); 
            dispatch({ type: 'CALCULATION_TOTALPRICE_NEW_ORDER'}); 
        }
    }

    return (dispatch) => {
        dispatch({ type: 'SET_SALE_SUM_NEW_ORDER', value: value }); 
        dispatch({ type: 'CALCULATION_TOTALPRICE_NEW_ORDER'}); 
    }
}

export function changePointNewOrder(point, city) {    
    return (dispatch) => {
        dispatch({ type: 'CHANGE_POINT_NEW_ORDER', point, city})
    }
}

export function calculationTotalPriceNewOrder() {
    return (dispatch) => {
        dispatch({ type: 'CALCULATION_TOTALPRICE_NEW_ORDER'}); 
    }
}

export function setZonesNewOrder(value) {
    if(value)
    {
        const data = value.filter(((item) => item.deliveryPrice > 0))
        let filteredData = data.map(item => ({
            deliveryPrice: item.deliveryPrice,
            deliveryCode: item.deliveryCode,
        }));

        if(filteredData.length === 0)
            filteredData = null

        return (dispatch) => {
            dispatch({ type: 'SET_ZONES_NEW_ORDER', value: filteredData})
        }
    }
    
    return (dispatch) => {
        dispatch({ type: 'SET_ZONES_NEW_ORDER', value: null})
    }    
}

export function addDeliveryPriced(price, article){
    return (dispatch) => {
        dispatch({ type: 'ADD_DELIVERY_PRICED_NEW_ORDER', price: price, article: article})
        dispatch({ type: 'CALCULATION_TOTALPRICE_NEW_ORDER'}); 
    }    
}

export function changeDeliveryMethodNewOrder(value) {    
    return (dispatch) => {
        dispatch({ type: 'CHANGE_DELIVERY_METHOD_NEW_ORDER', value: value})
            if(value === 'own')
            {
                dispatch({ type: 'ADD_DELIVERY_PRICED_NEW_ORDER', price: 0, article: null})
                dispatch({ type: 'CALCULATION_TOTALPRICE_NEW_ORDER'}); 
            }
    }
}

export function changeIsAggPriceNewOrder(value, goodsChek) {    
    return (dispatch) => {
        dispatch({ type: 'CHANGE_AGG_PRICE_NEW_ORDER', value: value, goodsChek: goodsChek})
        dispatch({ type: 'CALCULATION_TOTALPRICE_NEW_ORDER', goodsChek: goodsChek}); 
    }
}

export function changeInformationNewOrder(subtype, value) {    
    return (dispatch) => {
        dispatch({ type: 'CHANGE_INFORMATION_NEW_ORDER', subtype: subtype, value: value})
    }
}

export function changePaymentNewOrder(value) {
    return (dispatch) => {
        dispatch({ type: 'CHANGE_PAYMENT_NEW_ORDER', value: value})
    }
}

export function addTagNewOrder(tag) {
    return (dispatch) => {
        dispatch({ type: 'ADD_TAG_NEW_ORDER', tag: tag})
    }
}

export function changeChangeCashNewOrder(value) {
    return (dispatch) => {
        dispatch({ type: 'CHANGE_CHANGECASH_NEW_ORDER', data: value})
    }
}

export function clearNewOrder() {
    return(dispatch) => {
        dispatch({ type: 'CLEAR_NEW_ORDER'}); 
        dispatch({ type: 'SET_ORDER', order: null });
    }
}

export function saveNewOrder(){
    return(dispatch) => {
        dispatch({ type: 'SAVE_NEW_ORDER'}); 
    }
}

export function openEditOrder(order, point, goodsChek){
    return(dispatch) => {
        dispatch({ type: 'OPEN_EDIT_ORDER', order: order, point: point, goodsChek: goodsChek});
    }
}

export function openCopyOrder(order, goodsChek, point, isCopyAll){
    return(dispatch) => {
        dispatch({ type: 'OPEN_COPY_ORDER', order: order, goodsChek: goodsChek, point: point, isCopyAll: isCopyAll})
    }
}

export function addToCartPromo(goods) {
    return dispatch => {
        dispatch({ type: 'ADD_GOOD_PROMO', goods: goods });
        dispatch({ type: 'CALCULATION_TOTALPRICE_NEW_ORDER'});
    }
}

export function setPromotion(promo) {
    return dispatch => {
        dispatch({ type: 'SET_PROMO', promo: promo });
        dispatch({ type: 'CALCULATION_TOTALPRICE_NEW_ORDER'}); 
    }
}

export function clearPromotion() {
    return async dispatch => {
        dispatch({ type: 'CLEAR_PROMO' });
        dispatch({ type: 'CALCULATION_TOTALPRICE_NEW_ORDER'});
    }
}

export function fetchPromocodeHandler(data) {
    return (dispatch, getState) => {
        const goodsList = getState().good.list;
        const { promocode, city, deliveryMethod, totalPrice, goodsPrice, source } = data;
        dispatch({ type: 'SET_LOADER', field: 'orderPromo', value: true });

        const setErrorPromocode = (error) => {
            dispatch({ type: 'SET_ERROR_PROMOCODE', error });
        }

        if (!promocode) return setErrorPromocode('Промокод не введен');

        const params = {
            source,
            name: promocode.toLowerCase(),
        };

        return request({ method: 'get', url: `${urls.promocodes}`, params }).then((response) => {
            dispatch({ type: 'SET_LOADER', field: 'orderPromo', value: false });
            
            if (isEmpty(response)) return setErrorPromocode('Этого промокода не существует');
            const promocodeData = promocodeAdapter(response[0]);
            const sum = goodsPrice != null ? goodsPrice : totalPrice;
            const hasError = validatePromocode(promocodeData, deliveryMethod, city, sum, source, true);
            if (hasError) return setErrorPromocode(hasError);
            dispatch(setPromocode(promocodeData));
            if (promocodeData.type === 'addGoods') {
                const goods = promoGoodsAdapter(promocodeData.goods, goodsList);
                dispatch(addToCartPromo(goods));
            }
        })
        .catch((err) => {
            setErrorPromocode(`Ошибка поиска промокода: ${err.status || ''}`);
            dispatch({ type: 'SET_LOADER', field: 'orderPromo', value: false });
        });
    }
}

export function setPromocode(promocode) {
    return dispatch => {
        dispatch({ type: 'SET_ERROR_PROMOCODE', error: null });
        dispatch({ type: 'SET_PROMOCODE_ORDER', promocode: promocode });
        dispatch({ type: 'CALCULATION_TOTALPRICE_NEW_ORDER'}); 
    }
}